/** Recorded formats accepted by local import, account storage, and rendering. */
export const RECORDED_RIDE_SOURCES = ['fit', 'gpx', 'tcx'] as const;
export type RecordedRideSource = typeof RECORDED_RIDE_SOURCES[number];

export function isRecordedRideSource(value: unknown): value is RecordedRideSource {
  return RECORDED_RIDE_SOURCES.some(source => source === value);
}
